var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserService from '../../../services/user.service';
import * as log from '../../../utils/log';
import { connectWallet } from '../Wallet/slice';
export const getChatList = createAsyncThunk('chats/my', async () => {
    try {
        return await UserService.getChatList();
    }
    catch (err) {
        return err.response;
    }
});
export const getMessages = createAsyncThunk('messages/pages', async (getMessagesRequestPayload) => {
    try {
        return await UserService.getChatMessages(getMessagesRequestPayload);
    }
    catch (err) {
        return err.response;
    }
});
export const getNextMessages = createAsyncThunk('messages/pages/next', async (getMessagesRequestPayload) => {
    try {
        return await UserService.getChatMessages(getMessagesRequestPayload);
    }
    catch (err) {
        return err.response;
    }
});
export const readMessages = createAsyncThunk('messages/read', async (messages) => {
    try {
        const ids = messages.map((message) => message.id);
        return await UserService.readMessages(ids);
    }
    catch (err) {
        return err.response;
    }
});
export const createMessage = createAsyncThunk('messages', async (createMessageRequestPayload) => {
    try {
        return await UserService.createMessage(createMessageRequestPayload);
    }
    catch (err) {
        return err.response;
    }
});
export const getChat = createAsyncThunk('getChat', async (user, { dispatch }) => {
    try {
        const chatInfo = await UserService.getChat(user);
        dispatch(setUserChat(chatInfo.data));
        return;
    }
    catch (err) {
        return err.response;
    }
});
export const guildChat = createAsyncThunk('getGuildChat', async (guildId, { dispatch }) => {
    try {
        const chatInfo = await UserService.guildChat(guildId);
        dispatch(setUserChat(chatInfo.data));
        return;
    }
    catch (err) {
        return err.response;
    }
});
const setUserChatList = (state, action) => {
    state.pending = false;
    if (action.payload.status === 200 && action.payload) {
        state.chats = action.payload.data;
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
const setUserMessages = (state, action) => {
    var _a;
    if (action.payload.status === 200 && action.payload) {
        const messageListReq = action.payload.data;
        state.page = messageListReq.metadata.page;
        state.totalPages = messageListReq.metadata.totalPages;
        if (state.page > 1) {
            state.messages = [...state.messages, ...messageListReq.data];
        }
        else {
            state.messages = messageListReq.data;
        }
        if ((_a = state.chat) === null || _a === void 0 ? void 0 : _a.id) {
            state.chatsMessages[state.chat.id] = {
                messages: state.messages,
                page: state.page,
                totalPages: state.totalPages
            };
        }
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
const updateUserMessages = (state, action) => {
    var _a;
    state.pendingReadMessages = false;
    if (action.payload.status === 200 && action.payload) {
        const newMessages = action.payload.data;
        state.messages = state.messages.map((message) => {
            const newMessage = newMessages.find((item) => item.id === message.id);
            const chat = state.chats.find((chatItem) => chatItem.id === (newMessage === null || newMessage === void 0 ? void 0 : newMessage.chatId));
            if (chat && (newMessage === null || newMessage === void 0 ? void 0 : newMessage.isRead) && !message.isRead) {
                chat.state.unread--;
            }
            return newMessage ? newMessage : message;
        });
        if ((_a = state.chat) === null || _a === void 0 ? void 0 : _a.id) {
            state.chatsMessages[state.chat.id].messages = state.messages;
        }
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
const setNewMessage = (state, action) => {
    state.pending = false;
    if (action.payload.status === 200 && action.payload) {
    }
    if (action.payload.status !== 200) {
        log.error(action);
    }
};
const removeAllChatData = (state) => {
    state.chat = undefined;
    state.chats = [];
    state.messages = [];
    state.page = undefined;
    state.totalPages = undefined;
    state.needGetChatList = true;
};
export const initialState = {
    chats: [],
    messages: [],
    chatsMessages: {},
    newMessages: [],
    needGetChatList: true,
    pending: false,
    loadingMessages: false,
    loadingNewMessages: false,
    pendingReadMessages: false
};
export const slice = createSlice({
    name: 'chats',
    initialState,
    reducers: {
        setUserChat: (state, action) => {
            state.chat = action.payload;
            const chatMessages = state.chatsMessages[state.chat.id];
            if (chatMessages) {
                state.messages = chatMessages.messages;
                state.page = chatMessages.page;
                state.totalPages = chatMessages.totalPages;
            }
            else {
                state.messages = [];
            }
        },
        addNewMessage: (state, action) => {
            var _a;
            const payload = action.payload;
            if (state.chats.length) {
                const chat = state.chats.find((chatItem) => chatItem.id === payload.chatId);
                if (chat) {
                    const _b = payload.message, { user } = _b, last_message = __rest(_b, ["user"]);
                    chat.last_message = Object.assign(Object.assign(Object.assign({}, last_message), user), { date: last_message.createdAt });
                    if (!last_message.isRead) {
                        chat.state.unread++;
                        chat.state.all++;
                    }
                }
            }
            if (((_a = state.chat) === null || _a === void 0 ? void 0 : _a.id) === payload.chatId) {
                state.messages.unshift(payload.message);
            }
            if (state.chatsMessages[payload.chatId]) {
                state.chatsMessages[payload.chatId].messages.unshift(payload.message);
            }
        },
        clearMessages: (state) => {
            state.messages = [];
            state.page = undefined;
            state.totalPages = undefined;
        },
        clearChat: (state) => {
            state.chat = undefined;
        },
        clearChatData: (state) => {
            removeAllChatData(state);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getChatList.fulfilled, setUserChatList);
        builder.addCase(getChatList.pending, (state) => {
            state.pending = true;
            state.needGetChatList = false;
        });
        builder.addCase(getChatList.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(getMessages.fulfilled, (state, action) => {
            state.loadingMessages = false;
            setUserMessages(state, action);
        });
        builder.addCase(getMessages.pending, (state) => {
            state.loadingMessages = true;
        });
        builder.addCase(getMessages.rejected, (state) => {
            state.loadingMessages = false;
        });
        builder.addCase(getNextMessages.fulfilled, (state, action) => {
            state.loadingNewMessages = false;
            setUserMessages(state, action);
        });
        builder.addCase(getNextMessages.pending, (state) => {
            state.loadingNewMessages = true;
        });
        builder.addCase(getNextMessages.rejected, (state) => {
            state.loadingNewMessages = false;
        });
        builder.addCase(createMessage.fulfilled, setNewMessage);
        builder.addCase(createMessage.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(createMessage.rejected, (state) => {
            state.pending = false;
        });
        builder.addCase(readMessages.fulfilled, updateUserMessages);
        builder.addCase(readMessages.pending, (state) => {
            state.pendingReadMessages = true;
        });
        builder.addCase(readMessages.rejected, (state) => {
            state.pendingReadMessages = false;
        });
        builder.addCase(connectWallet.fulfilled, (state, action) => {
            removeAllChatData(state);
        });
    }
});
export const { addNewMessage, setUserChat, clearChat, clearMessages, clearChatData } = slice.actions;
export default slice.reducer;
